export default __webpack_public_path__ + "static/media/header-background-aboutus.10102739.webp";